'use client';

import { c as _c } from "react/compiler-runtime";
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { usePathname } from 'next/navigation';
import { useMemo, useState } from 'react';
import { SearchDialog } from '@/app/baza/_components/Search';
import { GeneralSearchResult } from '../../Search/_components/SearchResult/GeneralSearch';
import { SpecificCollectionSearchResult } from '../../Search/_components/SearchResult/SpecificCollectionSearch';
export function SearchButton() {
  const $ = _c(6);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const pathname = usePathname();
  let t0;
  bb0: {
    const segments = pathname.split("/");
    if (!segments[2] || segments[2] === "manage") {
      t0 = GeneralSearchResult;
      break bb0;
    }
    t0 = SpecificCollectionSearchResult;
  }
  const SearchResultComponent = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsSearchOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button type="button" onClick={t1} className="cursor-default"><MagnifyingGlassIcon className="size-6 text-contentTertiary" /></button>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsSearchOpen(false);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== SearchResultComponent || $[4] !== isSearchOpen) {
    t4 = <>{t2}<SearchDialog isOpen={isSearchOpen} onClose={t3} SearchResultComponent={SearchResultComponent} /></>;
    $[3] = SearchResultComponent;
    $[4] = isSearchOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}